<template>
  <div class="container-fluid" id="home">
    <div class="row wrapper">
      <div class="col-12 col-md-4">
        <div class="header">
          <div class="hero-image" alt="Your insurance needs"></div>
        </div>
      </div>
      <div class="col-12 col-md-8">
        <div class="main">
          <ValidationObserver v-slot="{ handleSubmit }" ref="form">
            <form @submit.prevent="handleSubmit(onSubmit)">
              <h1 tabindex="0">Find the right level of cover for you</h1>
              <p>This calculator helps provide an estimate of what you may currently need for death cover, total and permanent disablement (TPD) and income protection. </p>

              <ValidationProvider name="acceptedDisclaimer" :rules="{ required: { allowFalse: false, msg: 'You need to accept the assumptions & disclaimer to proceed.' } }" v-slot="{ errors }">
                <label class="checkbox-wrapper mt-4 mb-4">
                  <input type="checkbox" id="acceptedDisclaimer" name="acceptedDisclaimer" tabindex="0" @change="clickDisclaimer" v-model="acceptedDisclaimer" @blur="triggerHeightCheck()" data-analytics-capture-value="true"/>
                  <span class="checkmark"></span>
                  I accept the <router-link class="assumption-button col" :to="{ name: 'Assumptions', params: {activeTab: 'disclaimer' } }" tabindex="0">assumptions &amp; disclaimer</router-link>
                </label>
                <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }">{{ errors[0] }}</span>
              </ValidationProvider>

              <div class="nav-button mt-5 mb-4">
                <button class="next-button col" v-bind:class="[acceptedDisclaimer ? 'is-active' : 'is-disabled']" tabindex="0" role="button" type="submit" v-on:click="triggerHeightCheck">Let's get started</button>
              </div>
            </form>
          </ValidationObserver>
        </div>

      </div>
    </div>
    <CustomFooter></CustomFooter>
  </div>
</template>

<script>

import { mapFields } from "vuex-map-fields";
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import CustomFooter from '../components/CustomFooter';

extend('required', {
  ...required,
  params: ['msg'],
  message: '{msg}'
});

export default {
  name: 'Home',
  components: {ValidationProvider, ValidationObserver, CustomFooter},
  computed: {
    ...mapFields(["acceptedDisclaimer",]),
  },
  methods: {
    clickDisclaimer(e) {
      this.$store.commit("updateAcceptedDisclaimer",e.target.checked);
      this.triggerHeightCheck();
    },
    onSubmit () {
      this.$router.push('/intro');
      this.triggerHeightCheck();
    },
    triggerHeightCheck: function() { 
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },
  },
  mounted() {
    this.$refreshIframeHeight();
    this.$scrollIframeTop();
    window.addEventListener("resize", this.$refreshIframeHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  }
};
</script>
